import React, { Component } from 'react';
import { Upload,Button,Modal, Icon, message, Row, Col } from 'antd';
import moment from "moment"
import {config} from '../../../../../../config/fbConfig'
import Axios from 'axios';
class VideoUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videoUrl:"",
      visible: false,
      playerModal:false
    };
  
  }
  
  componentWillReceiveProps(props){
   if(props.refresh) props.getMedia(props.profile.uid)
  }
componentDidMount(){
  this.setState({videoUrl: this.props.videoUrl})
//   Axios({ method:"GET", url:"https://firebasestorage.googleapis.com/v0/b/awesome-67f16.appspot.com/o/" + encodeURIComponent("testfile.mp4")+ "?alt=media&token=https://firebasestorage.googleapis.com/v0/b/awesome-67f16.appspot.com/o/testfile.mp4?alt=media&token=6859486f-6235-40ce-b6ad-e4b67c5231d9" , data:{}, headers:{
//     Authorization: `Bearer ya29.a0Adw1xeU3Cz4YOvnS8EwOMcV7IBIdr9ONyXmIaZ_wjOQ-fjAey71SJfyeMrBAwJ2qaF1XmRzecBYBqZxrPo6nDJ_sp_RaS69_4xCA3eAzDUwSC78ZaLITIsp3W86CpemN68iobCaQxRVtXabSOOBt8z54FZ4V19jFpKI`
//   }, json: true })
//  .then((res)=>{
//     console.log(res)
//   }).catch((err)=>console.log(err))
}
handleChange = (videoUrl) => {
  this.props.handleVideoChange(videoUrl);
  this.setState({visible:false,videoUrl})
}
  onChange = (info)=> {
    const { status } = info.file;
    if (status === 'done') {
    var {name,timeCreated,mediaLink} = info.file.response;
    var {uid} = this.props.profile
    var media = {
      name:name.split('/')[2],url:mediaLink,type:'video',uid,timeCreated
    }
    this.props.uploadMedia(media)
    this.props.refreshVideos()
    console.log(info)
 
    message.success(`${info.file.name} file uploaded successfully.`);
    } else if (status === 'error') {
      console.log(info)
      message.error(`${info.file.name} file upload failed.`);
    }
  }
  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = e => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };
  data = (file)=>{
    return {
      projectId: config.projectId,
      destination: `videos/${this.props.profile.uid}/${file.name}`
   }
  }
  open=()=>{
    this.setState({playerModal:true})
    // window.open(url,'__blank')
  }
  sort=(a,b)=> new Date(b.timeCreated) - new Date(a.timeCreated);
  render() {
    const { videoUrl } = this.state;
    var {media} = this.props;
    
    const props = {
          accept:"video/*",
          listType:"picture",
          action:'https://orsityfileserver.herokuapp.com/fileupload',          
          // action:info=>`https://storage.googleapis.com/upload/storage/v1/b/awesome-67f16.appspot.com/o?uploadType=media&name=testfile.mp4`,          
          data:this.data,
          onChange:this.onChange,
          multiple :true,
    };
    return (
      <div className="clearfix xselect-video">
          <Modal
              visible={this.state.playerModal}
              onCancel={()=>this.setState({playerModal:false})}
            >
             <video src={videoUrl} controls style={{width:"100%"}} />
          </Modal>
        {videoUrl?
        <div className="choose-file added" >
        <Icon type="play-circle" className="play"/>
        <Icon type="delete" className="xremove" onClick={()=>this.handleChange('')}/>
        <Icon type="play-circle" className="open" onClick={this.open}/>
        
      
         </div> : <div className="choose-file" onClick={this.showModal}>
        <Icon type="plus" />
        <div className="ant-upload-text">Upload</div>
      </div>}
        <Modal
          title={<Upload
          {...props}
          >
            <Button>Upload files</Button>
          </Upload>
          }
          width={1200}
          style={{top:20}}
          className="xselect-modal"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          footer={
            <Button key="back" onClick={this.handleCancel}>
              Cancel
            </Button>
          }
        >
          <Row>
          {this.props.media && this.props.media.sort(this.sort).map((file,key)=>(
            <Col lg={8} sm={24} xs={24} key={key} onClick={()=>this.handleChange(file.url)}>
            <div key={key} className="list">
            <Row type="flex" align="middle">
            <Col  lg={3} sm={2} xs={2} >
           
            <Icon type="play-circle"/>
            </Col>              
            <Col  lg={21} sm={22} xs={22}>
              <div> {file.name} </div>
              <p>uploaded {moment(file.timeCreated).fromNow()}</p>
            </Col>
          </Row>
          </div>
            </Col>
          ))}
          </Row>
          
        </Modal>

      </div>
    );
  }
}
export default VideoUpload;
